import { getJsonRequest, putJsonRequest } from '@chilecompra/react-kit'
import { factoryService, getFileRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import { features } from '../config/settings/features'

/**
 * Update quote request to published status
 */
export const sendSellerQuoteBid = factoryService(({ quoteBidSeller }) => {
  const body = {
    codigoCotizacion: quoteBidSeller.quoteId,
    moneda: quoteBidSeller.currency,
    descripcion: quoteBidSeller.description,
    montoNeto: quoteBidSeller.netWorth,
    totalImpuesto: quoteBidSeller.taxation,
    codigoImpuesto: quoteBidSeller.taxationOption,
    montoTotal: quoteBidSeller.amount,
    montoDespacho: quoteBidSeller.dispatchValue,
    fechaCierre: quoteBidSeller.dateClose,
    productos: quoteBidSeller.products.map(product => ({
      solicitudCotizacionProductoId: product.productId,
      codigoProducto: product.productCode,
      cantidad: product.quantity,
      precioUnitario: product.unitValue,
      montoTotal: product.subtotal,
      incluir: product.included
    })),
    idRespuesta: quoteBidSeller.idRespuesta,
    ...(quoteBidSeller?.detalleAdicional && { detalleAdicional: quoteBidSeller.detalleAdicional }),
    ...(quoteBidSeller?.beneficiarios && { beneficiarios: quoteBidSeller.beneficiarios }),
    tokenReCaptcha: quoteBidSeller.tokenReCaptcha,
    ipUsuario: quoteBidSeller.userHost
  }

  return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/proveedor/cotizacion`, { body, retries: 0 })
})

/**
 * Get bid detail.
 */
export const getQuoteBid = factoryService(({ bidId }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/solicitud/cotizacion/${bidId}`)
)

/**
 * Get bid results, in excel.
 */
export const getResultExcel = factoryService(({ quoteId }) =>
  getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/${
      features['services.excel'] ? 'compra-agil-excel' : 'compra-agil'
    }/solicitud/${quoteId}/excel`
  )
)

/**
 * Cancel bid
 */
export const cancelBid = factoryService(({ bidId, ipUsuario }) => {
  const queryParams = new URLSearchParams({ ipUsuario })

  return putJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil//proveedor/cotizacion/anular/${bidId}?${queryParams}`)
})

/**
 * Download the send receipt PDF for a seller quote.
 */
export const getComprobanteEnvioPdf = factoryService(({ cotizacionId, codigoSolicitud }) => {
  if (cotizacionId) {
    return getFileRequest(
      `${REACT_APP_API_BASE_URL}/v1/compra-agil/proveedor/cotizacion/${cotizacionId}/comprobante-envio`
    )
  }

  return getFileRequest(
    `${REACT_APP_API_BASE_URL}/v1/compra-agil/proveedor/solicitud/${encodeURIComponent(
      codigoSolicitud
    )}/cotizacion/comprobante-envio`
  )
})
